import React from "react";

export const Bennu = () => {
  return (
      <div
        id={"bennu"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
  );
};


